export default {
    loading: "Chargement"
}